import React from 'react';
import { Content, FlexboxGrid } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import Success from '../../components/payment/common/success/Success';
import TaxSuccessFields from '../../components/payment/common/success/TaxSuccessFields';
import { FLOWS_ENUM } from '../../common/enums';

const TaxSuccess = () => {
  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={FLOWS_ENUM.PAY_TOT} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        as="main"
        id="main-content"
        tabIndex={-1}
        colspan={24}
        aria-label="Tax payment submitted"
      >
        <Content as="div">
          <Success
            successComponent={() => <TaxSuccessFields />}
            flow={FLOWS_ENUM.PAY_TOT}
          />
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default TaxSuccess;
